/* @flow */
import React, { PureComponent } from 'react';
import { Icon, message } from 'antd';
import { Link } from 'react-router-dom';
import { RouterProps } from 'react-router';
import Debounce from 'lodash-decorators/debounce';
import RightContent from './RightContent';
import styles from './GlobalHeader.module.pcss';
import Support from './Support';

type Props = {
  isCollapsed: boolean,
  onCollapse: (isCollapsed: boolean) => void,
  isMobile: boolean,
  logo: string,
  auth: AuthT,
  routerProps: RouterProps,
  signOut: () => void,
  saveSupportInfo: ({ formData: Array<string>, token: string }) => Promise<any>,
};

export default class GlobalHeader extends PureComponent<Props> {
  componentWillUnmount() {
    this.triggerResizeEvent.cancel();
  }

  @Debounce(600)
  triggerResizeEvent() {
    const event = document.createEvent('HTMLEvents');
    event.initEvent('resize', true, false);
    window.dispatchEvent(event);
  }

  toggle = () => {
    const { isCollapsed, onCollapse } = this.props;
    onCollapse(!isCollapsed);
    this.triggerResizeEvent();
  };

  render() {
    const { isCollapsed, isMobile, logo } = this.props;
    return (
      <div className={styles.header}>
        {isMobile && (
          <Link to="/" className={styles.logo} key="logo">
            <img src={logo} alt="logo" width="32" />
          </Link>
        )}
        <span role="button" tabIndex={0} className={styles.trigger} onKeyDown={null} onClick={this.toggle}>
          <Icon type={isCollapsed ? 'menu-unfold' : 'menu-fold'} />
        </span>
        <RightContent {...this.props} />
        <Support {...this.props} />
      </div>
    );
  }
}
